require("core-js/modules/es6.regexp.split");

!function (e, t) {
  "object" == typeof exports && "undefined" != typeof module ? module.exports = t() : "function" == typeof define && define.amd ? define(t) : (e.ReactIntlLocaleData = e.ReactIntlLocaleData || {}, e.ReactIntlLocaleData.yi = t());
}(this, function () {
  "use strict";

  return [{
    locale: "yi",
    pluralRuleFunction: function pluralRuleFunction(e, t) {
      var r = !String(e).split(".")[1];
      return t ? "other" : 1 == e && r ? "one" : "other";
    },
    fields: {
      year: {
        displayName: "יאָר",
        relative: {
          0: "הײַ יאָר",
          1: "איבער א יאָר",
          "-1": "פֿאַראַיאָר"
        },
        relativeTime: {
          future: {
            one: "איבער {0} יאָר",
            other: "איבער {0} יאָר"
          },
          past: {
            one: "פֿאַר {0} יאָר",
            other: "פֿאַר {0} יאָר"
          }
        }
      },
      "year-short": {
        displayName: "יאָר",
        relative: {
          0: "הײַ יאָר",
          1: "איבער א יאָר",
          "-1": "פֿאַראַיאָר"
        },
        relativeTime: {
          future: {
            one: "איבער א יאָר",
            other: "איבער {0} יאָר"
          },
          past: {
            one: "פֿאַר {0} יאָר",
            other: "פֿאַר {0} יאָר"
          }
        }
      },
      month: {
        displayName: "מאנאַט",
        relative: {
          0: "דעם חודש",
          1: "קומענדיקן חודש",
          "-1": "פֿאַרגאנגענעם חודש"
        },
        relativeTime: {
          future: {
            one: "איבער {0} חודש",
            other: "איבער {0} חדשים"
          },
          past: {
            one: "פֿאַר {0} חודש",
            other: "פֿאַר {0} חדשים"
          }
        }
      },
      "month-short": {
        displayName: "מאנאַט",
        relative: {
          0: "דעם חודש",
          1: "קומענדיקן חודש",
          "-1": "פֿאַרגאנגענעם חודש"
        },
        relativeTime: {
          future: {
            one: "איבער {0} חודש",
            other: "איבער {0} חדשים"
          },
          past: {
            one: "פֿאַר {0} חודש",
            other: "פֿאַר {0} חדשים"
          }
        }
      },
      day: {
        displayName: "טאָג",
        relative: {
          0: "היינט",
          1: "מארגן",
          "-1": "נעכטן"
        },
        relativeTime: {
          future: {
            one: "אין {0} טאָג אַרום",
            other: "אין {0} טעג אַרום"
          },
          past: {
            other: "-{0} d"
          }
        }
      },
      "day-short": {
        displayName: "טאָג",
        relative: {
          0: "היינט",
          1: "מארגן",
          "-1": "נעכטן"
        },
        relativeTime: {
          future: {
            one: "אין {0} טאָג אַרום",
            other: "אין {0} טעג אַרום"
          },
          past: {
            other: "-{0} d"
          }
        }
      },
      hour: {
        displayName: "שעה",
        relative: {
          0: "this hour"
        },
        relativeTime: {
          future: {
            other: "+{0} h"
          },
          past: {
            other: "-{0} h"
          }
        }
      },
      "hour-short": {
        displayName: "שעה",
        relative: {
          0: "this hour"
        },
        relativeTime: {
          future: {
            other: "+{0} h"
          },
          past: {
            other: "-{0} h"
          }
        }
      },
      minute: {
        displayName: "מינוט",
        relative: {
          0: "this minute"
        },
        relativeTime: {
          future: {
            other: "+{0} min"
          },
          past: {
            other: "-{0} min"
          }
        }
      },
      "minute-short": {
        displayName: "מינוט",
        relative: {
          0: "this minute"
        },
        relativeTime: {
          future: {
            other: "+{0} min"
          },
          past: {
            other: "-{0} min"
          }
        }
      },
      second: {
        displayName: "סעקונדע",
        relative: {
          0: "now"
        },
        relativeTime: {
          future: {
            other: "+{0} s"
          },
          past: {
            other: "-{0} s"
          }
        }
      },
      "second-short": {
        displayName: "סעקונדע",
        relative: {
          0: "now"
        },
        relativeTime: {
          future: {
            other: "+{0} s"
          },
          past: {
            other: "-{0} s"
          }
        }
      }
    }
  }];
});